<template>
  <div class="course-more">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :head-height="100">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="articleList.length>0?'没有更多了':''"
        @load="onLoad"
        :immediate-check="false"
      >
        <van-swipe-cell v-for="(article, i) in articleList" :key="i">
          <must-know-item :article="article" :title="title"></must-know-item>
        </van-swipe-cell>
        <div v-show="articleList.length===0&&loading===false" style="text-align:center;">
          <img
            style="width:200px;"
            :src="require('../../assets/images/no-data.png')"
            >
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import MustKnowItem from '../guide/MustKnowItem'
export default {
  components: {MustKnowItem},
  props: {
    typecode: Number,
    title:String
  },
  data () {
    return {
      page: 0,
      size: 10,
      loading: true,
      finished: false,
      refreshing: false,
      sortId: 1,
      articleList: [],
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.onLoad()
    },
    onLoad () {
      setTimeout(() => {
        if (this.refreshing) {
          this.articleList = []
          this.refreshing = false
          this.page = 1
        } else {
          this.page++
        }
        this.getDocData()
      }, 1000)
    },
    onRefresh () {
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    getDocData () {
      let params = {
        "typecode": this.typecode,
        "pagesize": this.size,
        "pageindex": this.page
      }
      this.loading = true
      this.$http.post(this.$api.getArticles, params).then(res => {
        this.loading = false
        if(res.data){
          this.articleList = this.articleList.concat(res.data)
          if (this.articleList.length >= parseInt(res.totalcount)) {
            this.finished = true
          }
        }else{
          this.finished = true
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.course-more{
  margin-bottom: 10px;;
  .seperator{
    height: 7px;
  }
}
.van-swipe-cell__right{
  height: 107px;
  .van-button--small{
    height: 30px;
    width: 43px;
    height: 43px;
    margin-top: 30px;
    margin-left: 13px;
    min-width: 43px;
  }
  .van-button--danger{
    background-color: '#E6E6E6';
    border: 0;
    color: '#F74F4F';
    font-size: '16px';
  }
}
</style>
